import { Rocket, TrendingUp, ScanSearch, Handshake, ArrowUpRight } from "lucide-react";

const services = [
  {
    id: "startups",
    icon: Rocket,
    tag: "01 / FRACTIONAL GTM ADVISOR",
    subtitle: "For startups & SMBs",
    title: "A senior GTM brain, on retainer.",
    body:
      "An ongoing monthly advisory relationship for founders and early revenue leaders. Chris embeds as a fractional GTM voice — sharpening ICP, positioning, and founder-led sales — without adding to your headcount or handing off a deliverable that gathers dust.",
    bullets: ["2 working sessions / month", "Async review of decks, plans & hires", "Direct line between sessions"],
  },
  {
    id: "scaleups",
    icon: TrendingUp,
    tag: "02 / EXECUTIVE ADVISOR",
    subtitle: "For scale-ups",
    title: "Board-caliber counsel for the revenue org.",
    body:
      "An executive advisory engagement for CEOs, CROs and CMOs scaling past $10M ARR. Chris advises on RevOps design, AI enablement roadmaps, and pipeline discipline — you own execution, he stress-tests the thinking.",
    bullets: ["Monthly leadership cadence", "Quarterly board-level review", "AI enablement roadmap"],
  },
  {
    id: "review",
    icon: ScanSearch,
    tag: "03 / GTM DIAGNOSTIC",
    subtitle: "One-off · 4–6 weeks",
    title: "A written thesis on your GTM.",
    body:
      "A structured advisory review of your motion — tech stack, team shape, and pipeline health. You leave with a written GTM thesis, a prioritized list of efficiency leaks, and the AI plays worth running next. Advisory only; you or your team implements.",
    bullets: ["Stack & team diagnostic", "Pipeline health read", "Written GTM thesis"],
  },
  {
    id: "corporate",
    icon: Handshake,
    tag: "04 / CORPORATE ADVISOR",
    subtitle: "For early-stage · Success fee",
    title: "Capital, network, and the plan to earn both.",
    body:
      "For early-stage companies preparing to raise. Chris supports the capital-raising motion end-to-end — strategic guidance on narrative and metrics, warm access to his investor network, and coaching through the process. Compensation is a percentage of a successful raise.",
    bullets: ["Raise narrative & GTM metrics", "Introductions to relevant capital", "Investor prep coaching"],
  },
];

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <div className="text-xs font-mono-ui uppercase tracking-[0.28em] text-violet-400 mb-4">
              ─── Services
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light tracking-tighter text-zinc-50 max-w-2xl">
              Four ways to work with Chris.
            </h2>
          </div>
          <p className="max-w-md text-base text-zinc-400 leading-relaxed">
            No agency work, no implementation. Recurring counsel for founders
            and revenue leaders, one deep diagnostic, and a corporate advisor
            engagement for capital-raising stage teams.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
          {services.map((s) => {
            const Icon = s.icon;
            return (
              <article
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className="card-hover group relative bg-zinc-950 p-8 md:p-10 flex flex-col"
              >
                <div className="flex items-center justify-between mb-8">
                  <div>
                    <span className="text-[11px] font-mono-ui uppercase tracking-[0.24em] text-zinc-500 group-hover:text-violet-400 transition-colors block">
                      {s.tag}
                    </span>
                    <span className="text-[11px] text-zinc-500 mt-1 block">
                      {s.subtitle}
                    </span>
                  </div>
                  <span className="inline-flex h-10 w-10 items-center justify-center border border-white/10 group-hover:border-violet-400/50 group-hover:bg-violet-500/10 transition-all">
                    <Icon className="h-4 w-4 text-zinc-300" strokeWidth={1.5} />
                  </span>
                </div>
                <h3 className="font-display text-2xl md:text-[26px] font-medium tracking-tight text-zinc-50 leading-snug">
                  {s.title}
                </h3>
                <p className="mt-4 text-sm text-zinc-400 leading-relaxed">
                  {s.body}
                </p>
                <ul className="mt-8 space-y-2.5 border-t border-white/5 pt-6">
                  {s.bullets.map((b) => (
                    <li
                      key={b}
                      className="flex items-center gap-3 text-sm text-zinc-300"
                    >
                      <span className="h-px w-4 bg-violet-400/60" />
                      {b}
                    </li>
                  ))}
                </ul>
                <a
                  href="#contact"
                  data-testid={`service-cta-${s.id}`}
                  className="mt-10 inline-flex items-center gap-2 text-sm text-zinc-300 hover:text-violet-300 transition-colors"
                >
                  Start a conversation
                  <ArrowUpRight className="h-3.5 w-3.5" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};
